import { defineMessages } from '../../i18n/messages';
import { englishText } from '../../utils/messageFallbacks';

/*
 * The index previously had a bare <h1>Blog</h1> and no description — nothing telling
 * a visitor (or a crawler) what the articles are about.
 *
 * Article titles and descriptions are not here on purpose: they live in each MDX
 * file's frontmatter and are English-only, like the article bodies they introduce.
 * Translating the chrome around untranslated posts is the honest half.
 */
const DEFINITIONS = {
  PAGE_TITLE: {
    id: 'blog.page_title',
    text: 'Blog',
    description: 'Heading of the blog index page',
  },
  PAGE_LEDE: {
    id: 'blog.page_lede',
    text: 'Practical guides to internationalizing real applications — framework setup, CI/CD pipelines, placeholder safety, and where AI translation earns its place.',
    description: 'Introductory paragraph under the blog index heading, describing what the articles cover',
  },
  LATEST: {
    id: 'blog.latest',
    text: 'Latest',
    description: 'Small label marking the most recent article, shown above its title',
  },
  EMPTY: {
    id: 'blog.empty',
    text: 'Articles coming soon.',
    description: 'Shown on the blog index when no articles are published',
  },
  BACK_TO_BLOG: {
    id: 'blog.back_to_blog',
    text: 'All articles',
    description: 'Link at the top of an article returning to the blog index',
  },
  CTA_TITLE: {
    id: 'blog.cta_title',
    text: 'Try it on your own project',
    description: 'Heading of the call to action shown at the end of an article',
  },
  CTA_TEXT: {
    id: 'blog.cta_text',
    text: 'Install the CLI and translate your first 5,000 words free. No credit card required.',
    description: 'Body of the call to action shown at the end of an article',
  },
  CTA_BUTTON: {
    id: 'blog.cta_button',
    text: 'Get started',
    description: 'Button label of the call to action shown at the end of an article',
  },
} as const;

export const BlogIndexMessages = defineMessages(DEFINITIONS);
export const BlogIndexText = englishText(DEFINITIONS);
